export default "__VITE_ASSET__BMM5hEBt__"